import Papa from 'papaparse';

const downloadCsv = (props) => {

  let arrayOfObj = props.arrayOfObj;
  let fileName   = props.fileName;

  var csv = Papa.unparse(arrayOfObj);

  var csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
  var csvURL =  null;
  if (navigator.msSaveBlob)
  {
    csvURL = navigator.msSaveBlob(csvData, `${fileName}`);
  }
  else
  {
    csvURL = window.URL.createObjectURL(csvData);
  }

  var tempLink = document.createElement('a');
  tempLink.href = csvURL;
  tempLink.setAttribute('download', `${fileName}`);
  tempLink.click();
}


export default downloadCsv;